var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAssessmentNotstarted = function SvgAssessmentNotstarted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 45,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A5A3",
    d: "M71 25.5h.5v-1H71v1ZM51.667 25a2.667 2.667 0 1 0-5.334 0 2.667 2.667 0 0 0 5.334 0ZM71 25v-.5H49v1h22V25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFCF80",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M22.781 30.938v3.937",
    opacity: 0.34
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFCF80",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M13.406 41.25h18.75v-1.875a3.761 3.761 0 0 0-3.75-3.75h-11.25a3.761 3.761 0 0 0-3.75 3.75v1.875Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFCF80",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M11.531 41.25h22.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFCF80",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M22.5 30c-7.256 0-13.125-5.869-13.125-13.125V11.25c0-4.144 3.356-7.5 7.5-7.5h11.25c4.144 0 7.5 3.356 7.5 7.5v5.625C35.625 24.131 29.756 30 22.5 30Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFCF80",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.256 21.844c-1.406-.45-2.644-1.275-3.619-2.25-1.687-1.875-2.812-4.125-2.812-6.75s2.062-4.688 4.687-4.688h1.22a7.042 7.042 0 0 0-.563 2.813v5.625c0 1.875.393 3.637 1.087 5.25ZM34.744 21.844c1.406-.45 2.644-1.275 3.618-2.25 1.688-1.875 2.813-4.125 2.813-6.75s-2.063-4.688-4.688-4.688H35.27c.375.863.562 1.819.562 2.813v5.625c0 1.875-.394 3.637-1.087 5.25Z",
    opacity: 0.34
  })));
};
export default SvgAssessmentNotstarted;